import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService } from '../../shared';

@Component({
  selector: 'data-consolidation',
  styles: [require('./data-consolidation.component.scss'), require('.//../static.scss')],
  template: require('./data-consolidation.component.html')
})
export class DataConsolidationComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService) {
    // Do stuff
  }

  title = 'Data Consolidation - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';


  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/data-consolidation/data-consolidation.component.ts